@if (product$(); as productData) {
  <app-product-panel-atom
    [product]="productData"
    [additions]="additions()"
    [isDisableButton]="!isButtonValid"
    [additionsByGroup]="additionsByGroup()"
    [shopOpensAt]="shopOpensAt"
    [compoundItems]="declinables()"
    [allowAddToCart]="staticAllowAddToCart"
    [index]="$any(index$ | async)"
    [headingColor]="headingColor"
    [descriptionColor]="descriptionColor"
    [inactiveStateColor]="inactiveStateColor"
    [priceColor]="priceColor"
    [displayPrice]="displayPrice"
    [maxProduct]="maxProduct"
    [backgroundColor]="backgroundColor"
    [textColor]="textColor"
    [buttonBackgroundColor]="buttonBackgroundColor"
    [buttonTextColor]="buttonTextColor"
    [tagColors]="$any(tagColors$ | async)"
    [hideAdditionGroupDetails]="hideAdditionGroupDetails"
    (addProduct)="addToCart()"
    (closePanel)="close()"
    (toggleAddition)="onSelectAddition($event)"
    (changeQuantity)="onChangeNbProduct($event)"
    (changeAdditionQuantity)="onChangeNbAddition($event)"
    (openCompound)="openCompound($event)"
  ></app-product-panel-atom>
}
